import api from './api';

const clientService = {
  getClientes: async () => {
    try {
      const response = await api.get('/api/clientes');
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener clientes';
    }
  },

  getCliente: async (clienteId) => {
    try {
      const response = await api.get(`/api/clientes/${clienteId}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener cliente';
    }
  },

  createCliente: async (clienteData) => {
    try {
      const response = await api.post('/api/clientes', clienteData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al crear cliente';
    }
  },

  updateCliente: async (clienteId, clienteData) => {
    try {
      const response = await api.put(`/api/clientes/${clienteId}`, clienteData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al actualizar cliente';
    }
  },

  deleteCliente: async (clienteId) => {
    try {
      await api.delete(`/api/clientes/${clienteId}`);
      return true;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al desactivar cliente';
    }
  }
};

export default clientService;